const REDIRECT_KEY = 'auth_redirect'

// Routes we must never redirect back to — checked at exact-path or segment boundaries
// to prevent false-positives (e.g. a future /login-history route would not be blocked).
const AUTH_PATHS = ['/login', '/forgot-password', '/reset-password']

// Matches anything that looks like a URI scheme (e.g. http:, javascript:, data:).
const SCHEME_RE = /^[a-z][a-z0-9+\-.]*:/i

function isSafeRedirectPath(raw: string): boolean {
  if (!raw || typeof raw !== 'string') return false
  if (raw.length > 500) return false

  // Must start with exactly one slash — no protocol-relative `//foo.com`.
  if (!raw.startsWith('/') || raw.startsWith('//')) return false

  // Reject anything that looks like a URI scheme.
  if (SCHEME_RE.test(raw)) return false

  // Reject user-info and Windows path characters.
  if (raw.includes('@') || raw.includes('\\')) return false

  // Decode and re-check to catch double-encoded attacks (%2F%2F, %40, …).
  let decoded: string
  try {
    decoded = decodeURIComponent(raw)
  } catch {
    return false
  }

  if (!decoded.startsWith('/') || decoded.startsWith('//')) return false
  if (SCHEME_RE.test(decoded)) return false
  if (decoded.includes('@') || decoded.includes('\\')) return false

  // Block auth-only routes using exact match or path-segment boundary
  // so that a hypothetical future /login-history route is not accidentally blocked.
  const isAuthPath = AUTH_PATHS.some(
    (p) => decoded === p || decoded.startsWith(p + '/') || decoded.startsWith(p + '?'),
  )
  if (isAuthPath) return false

  return true
}

export function saveIntendedUrl(fullPath: string): void {
  if (isSafeRedirectPath(fullPath)) {
    sessionStorage.setItem(REDIRECT_KEY, fullPath)
  }
}

// Read, validate, and atomically clear the stored redirect.
// Returns null if nothing was stored or if the stored value fails validation.
export function consumeIntendedUrl(): string | null {
  const stored = sessionStorage.getItem(REDIRECT_KEY)
  sessionStorage.removeItem(REDIRECT_KEY) // always clear, even when rejecting

  if (stored && isSafeRedirectPath(stored)) {
    return stored
  }
  return null
}

export function clearIntendedUrl(): void {
  sessionStorage.removeItem(REDIRECT_KEY)
}
